<template>
  <Dialog
    ref="dialogRef"
    custom-class="pg-dialog-ocr"
    :visible="visible"
    :modal="false"
    top=""
    width="auto"
    :show-close="false"
    @close="close"
  >
    <div class="pg-dialog-ocr__content">
      <PgOcrType
        class="pg-dialog-ocr__content-type"
        :class="{
          'pg-dialog-ocr__content-type--flot': !!attach,
          'pg-dialog-ocr__content-type--no-bor': !expand && !!attach,
        }"
        :show="expand"
        :types="ocrTypes"
        @on-upload="setAttach"
      >
        <div class="pg-dialog-ocr__content-header" v-dialog-drag="dialogRef">
          <div class="pg-dialog-ocr__content-header-left">
            <PgOcrWawa class="pg-dialog-ocr__content-header-left-wawa"></PgOcrWawa>
            你好，我是你的AI小助手哦~
            <span class="pg-dialog-ocr__content-header-left-separated" v-if="!!attach"></span>
            <span
              class="pg-dialog-ocr__content-header-operation"
              v-if="!!attach"
              @click="swichExpand"
              >{{ expand ? '收起' : '展开'
              }}<i
                class="ivu-icon-icon-pg-xiangshang"
                :class="{ 'pg-dialog-ocr__content-header-operation-icon--xia': !expand }"
              ></i
            ></span>
          </div>
          <i class="el-dialog__close el-icon el-icon-close" @click="close"></i>
        </div>
      </PgOcrType>
      <div class="pg-dialog-ocr__content-bottom" v-if="!!attach">
        <div class="pg-dialog-ocr__content-bottom-box">
          <PgFilePreview
            class="pg-dialog-ocr__content-bottom-box-left"
            ref="filePreviewRef"
            :visible="visible"
            :value="attach"
            :space.sync="isSpace"
          ></PgFilePreview>
          <PgOcrResult :ocrData="ocrData" :ocrType="ocrType"></PgOcrResult>
        </div>
        <div class="pg-dialog-ocr__content-bottom-btns">
          <div class="pg-dialog-ocr__content-bottom-btns-l">
            <div class="pg-dialog-ocr__content-bottom-btns-left">
              <span
                class="pg-dialog-ocr__content-bottom-btns-left-icon-1"
                title="实际大小"
                @click="initSize"
                >1:1</span
              >
              <i class="el-icon-zoom-out" title="缩小" @click="zoom(1)"></i>
              <i class="el-icon-zoom-in" title="放大" @click="zoom(-1)"></i>
            </div>
          </div>
          <div class="pg-dialog-ocr__content-bottom-btns-r"></div>
        </div>
      </div>
    </div>
  </Dialog>
</template>
<script setup>
import { Dialog, Loading } from 'element-ui'
import PgOcrType from './ocr-type.vue'
import PgOcrWawa from './ocr-wawa.vue'
import { PgFilePreview } from '../../file-preview/index'
import { ref } from 'vue'
import { post, vDialogDrag, getImageByScan } from '../../../utils/index'
import PgOcrResult from './ocr-result.vue'

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  ocrTypes: Array,
})
const emit = defineEmits(['close'])

const expand = ref(true)
const swichExpand = () => {
  expand.value = !expand.value
}

const isSpace = ref(false)

const dialogRef = ref(null)

const filePreviewRef = ref(null)
const initSize = () => {
  filePreviewRef.value.initSize()
}
const zoom = (val) => {
  filePreviewRef.value.zoom(val, 0.1)
}
const attach = ref(null)
const ocrData = ref('')
const ocrType = ref(null)
const setAttach = async ({ url, btnItem, imgType }) => {
  if (url) attach.value = url
  let loadingInstance = Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
  if (imgType === 'camera') {
    const imgRes = await getImageByScan({ catalogCode: 'OCR_IMAGE' }).catch(() => null)
    if (!imgRes?.data?.url) {
      loadingInstance.close()
      return
    }
    attach.value = imgRes.data.url
  }

  const [res] = await post(
    `${btnItem.url ?? 'rest/ezcomp/ocr/recognizeAllText2Json/'}${btnItem.code}`,
    {
      url: attach.value,
    }
  )
  loadingInstance.close()
  swichExpand()
  if (res?.data) {
    const resData = res.data
    ocrType.value = btnItem
    if (btnItem.code === 'Advanced') {
      ocrData.value = joinStr(resData?.subImages?.[0]?.blockInfo?.blockDetails ?? [])
    } else if (btnItem.code === 'Registration') {
      ocrData.value = resData?.kvInfo ?? {}
    } else {
      ocrData.value = resData?.subImages?.[0]?.kvInfo?.data ?? {}
    }
  } else {
    ocrType.value = btnItem
    ocrData.value = btnItem.code === 'Advanced' ? '' : {}
  }
}
const close = () => {
  emit('update:visible', false)
}

const joinStr = (subs = []) => {
  return subs.reduce((pre, cur) => {
    return (pre += `${cur.blockContent}\n`)
  }, '')
}
</script>
<style lang="scss">
@import '../style/dialog-ocr.scss';
</style>
